import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import { HERO_CTA_ID } from './FixedCta';

// Accroche principale : titre, promesse et appels à l'action.
const HomeHero: React.FC = () => {
  const t = useT();
  // Le mot « gratuitement » est surligné : on découpe la phrase traduite autour de {free}.
  const [before, after = ''] = t('Organisez {free} tout votre mariage.').split('{free}');
  return (
    <section className="mk-hero mk-container">
      <div className="mk-hero-text">
        <span className="mk-badge">{t('100 % gratuit · Sans carte bancaire')}</span>
        <h1 className="mk-hero-title">
          {before}
          <mark className="mk-mark">{t('gratuitement')}</mark>
          {after} <em>{t('Sans jamais ouvrir Excel.')}</em>
        </h1>
        <p className="mk-lead">
          {t(
            'Répondez à quelques questions : RSVP Please prépare chaque étape de votre mariage, avec vos invités, votre budget et votre plan de table au même endroit.',
          )}
        </p>
        <div className="mk-cta-row" id={HERO_CTA_ID}>
          <Link to="/signup" className="mkt-btn primary mk-btn-lg">
            {t('Commencer gratuitement')}
          </Link>
        </div>
        <p className="mk-note">{t('Prêt en 2 minutes, sans rien installer')}</p>
      </div>
    </section>
  );
};

export default HomeHero;
